import { ReactElement } from 'react'

/**
 * @description
 * checks if there is a sidebar, if that sidebar is fixed and if it is on the left side
 **/
export const determineSidebarState = (children: ReactElement[]) => {
    const sidebar = children.filter((child) => child?.props.paneType?.includes('sidebar'))?.[0]

    if (!sidebar) {
        return {
            layoutHasSidebar: false,
            sidebarIsFixed: false,
            sidebarIsOnLeftSide: false,
        }
    }

    return {
        layoutHasSidebar: true,
        sidebarIsFixed: !!sidebar.props.paneType?.includes('fixed'),
        sidebarIsOnLeftSide: !!sidebar.props.paneType?.includes('left'),
    }
}
